import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { HeadContentSymbol, DomReadySymbol, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { IAppWillMountHandler, IHeadContent } from '@wix/thunderbolt-symbols'
import type { CustomCssSiteConfig, ICustomCssAPI } from './types'
import { CustomCssAPISymbol, name } from './symbols'
import { customCssId, ViewEnvironment } from './constants'

export const wrapInStyleElement = (css: string) => {
	return `<style id=${customCssId}>${css}</style>`
}

export const ServerCustomCss = withDependencies(
	[named(SiteFeatureConfigSymbol, name), HeadContentSymbol, CustomCssAPISymbol],
	(siteFeatureConfig: CustomCssSiteConfig, head: IHeadContent, customCssAPI: ICustomCssAPI): IAppWillMountHandler => {
		return {
			async appWillMount() {
				const cssCode = await customCssAPI.fetchStyles(siteFeatureConfig.gridAppId, ViewEnvironment.PUBLIC)
				if (cssCode) {
					head.addCustomCss(wrapInStyleElement(cssCode))
				}
			},
		}
	}
)

export const ClientCustomCss = withDependencies(
	[named(SiteFeatureConfigSymbol, name), DomReadySymbol, CustomCssAPISymbol],
	(
		siteFeatureConfig: CustomCssSiteConfig,
		domReadyPromise: Promise<void>,
		customCssAPI: ICustomCssAPI
	): IAppWillMountHandler => {
		return {
			async appWillMount() {
				await domReadyPromise
				const customCSSElement = document.getElementById(customCssId)
				if (customCSSElement) {
					return
				}
				const cssCode = await customCssAPI.fetchStyles(siteFeatureConfig.gridAppId, ViewEnvironment.PUBLIC)
				if (cssCode) {
					const styleElement = window.document.createElement('style')
					styleElement.setAttribute('id', customCssId)
					styleElement.innerHTML = cssCode
					window.document.head.appendChild(styleElement)
				}
			},
		}
	}
)
